import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SuiCollapse } from "./directives/collapse";
var SuiCollapseModule = /** @class */ (function () {
    function SuiCollapseModule() {
    }
    SuiCollapseModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        SuiCollapse
                    ],
                    exports: [
                        SuiCollapse
                    ]
                },] },
    ];
    /** @nocollapse */
    SuiCollapseModule.ctorParameters = function () { return []; };
    return SuiCollapseModule;
}());
export { SuiCollapseModule };
//# sourceMappingURL=collapse.module.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/collapse/collapse.module.js
// module id = 1098
// module chunks = 0